"use client";

import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function ArticleCta() {
  const { t } = useLanguage();
  return (
    <section className="bg-[#fbbf24] text-[#064e3b] py-16 my-12">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold">
          {t("blog.codes.ctaTitle")}
        </h2>
        <p className="mt-4 text-[#064e3b]/80 max-w-xl mx-auto">
          {t("blog.codes.ctaBody")}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:7863774452"
            className="inline-block bg-[#064e3b] text-white font-bold px-8 py-3 rounded-lg hover:bg-[#047857] transition whitespace-nowrap"
          >
            {t("hood.callNow")}
          </a>
          <Link
            to="/legal-disclaimer/"
            className="inline-block border-2 border-[#064e3b] text-[#064e3b] font-bold px-8 py-3 rounded-lg hover:bg-[#064e3b] hover:text-white transition whitespace-nowrap"
          >
            {t("hood.getQuote")}
          </Link>
        </div>
      </div>
    </section>
  );
}